import { render, staticRenderFns } from "./VaultSetupSameDevice.vue?vue&type=template&id=2e20684f&scoped=true"
import script from "./VaultSetupSameDevice.vue?vue&type=script&lang=js"
export * from "./VaultSetupSameDevice.vue?vue&type=script&lang=js"
import style0 from "./VaultSetup.scss?vue&type=style&index=0&id=2e20684f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20684f",
  null
  
)

export default component.exports